import React, { useState } from 'react';
import { Breadcrumb, Row, Col, Popover } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Background1 from '../../../../static/img/bg-api-type1.png';
import Background2 from '../../../../static/img/bg-api-type2.png';
import Background3 from '../../../../static/img/bg-api-type3.png';
import Background4 from '../../../../static/img/bg-api-type4.png';
import Background5 from '../../../../static/img/bg-api-type5.png';
import Background6 from '../../../../static/img/bg-api-type6.png';
import {
    queryAPIPullTotal, queryAPIPushTotal, queryAPIPubSubTotal,
    queryAPIAppTotal, queryAPIDeveloperTotal, queryAPIBindUserTotal
} from "./gqls";
import Client from '../../../../lib/gqlClient';
const APIDataTitlePage = (props) => {

    const navigate = useNavigate();
    const [APIPullPart, setAPIPullPart] = useState(0)
    const [APIPullTotal, setAPIPullTotal] = useState(0)
    const [APIPushPart, setAPIPushPart] = useState(0)
    const [APIPushTotal, setAPIPushTotal] = useState(0)
    const [APIPubSubPart, setAPIPubSubPart] = useState(0)
    const [APIPubSubTotal, setAPIPubSubTotal] = useState(0)
    const [APIAppTotal, setAPIAppTotal] = useState(0)
    const [APIDeveloperTotal, setAPIDeveloperTotal] = useState(0)
    const [APIBindUserPart, setAPIBindUserPart] = useState(0)
    const [APIBindUserTotal, setAPIBindUserTotal] = useState(0)

    React.useEffect(() => {
        Client(
            queryAPIPullTotal,
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setAPIPullPart(toThousands(res.data.openAPIPullTotal.part))
                setAPIPullTotal(toThousands(res.data.openAPIPullTotal.total))
            }
        }).catch(e => {
            // console.log(e);
        })
        Client(
            queryAPIPushTotal,
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setAPIPushPart(toThousands(res.data.openAPIPushTotal.part))
                setAPIPushTotal(toThousands(res.data.openAPIPushTotal.total))
            }
        }).catch(e => {
            // console.log(e);
        })
        Client(
            queryAPIPubSubTotal,
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setAPIPubSubPart(toThousands(res.data.openAPIPubSubTotal.part))
                setAPIPubSubTotal(toThousands(res.data.openAPIPubSubTotal.total))
            }
        }).catch(e => {
            // console.log(e);
        })
        Client(
            queryAPIAppTotal,
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setAPIAppTotal(toThousands(res.data.openAPIAppTotal))
            }
        }).catch(e => {
            // console.log(e);
        })
        Client(
            queryAPIDeveloperTotal,
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setAPIDeveloperTotal(toThousands(res.data.openAPIDeveloperTotal))
            }
        }).catch(e => {
            // console.log(e);
        })
        Client(
            queryAPIBindUserTotal,
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setAPIBindUserPart(toThousands(res.data.openAPIBindUserTotal.part))
                setAPIBindUserTotal(toThousands(res.data.openAPIBindUserTotal.total))
            }
        }).catch(e => {
            // console.log(e);
        })
    }, [])
    function onStart() {
        props.setNewKey('developerCenter/apiDataNoticfication')
        navigate('/developerCenter/apiDataNoticfication')

    }
    return (
        <div style={{ height: '660px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
            <Breadcrumb style={{ marginLeft: '20px', paddingTop: '6px' }}>
                <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                <Breadcrumb.Item><a a onClick={onStart} style={{ fontSize: '12px' }}>API Dashboard</a></Breadcrumb.Item>
                <Breadcrumb.Item><a style={{ fontSize: '12px' }}>数据统计</a></Breadcrumb.Item>
            </Breadcrumb>

            <Row style={{ marginTop: '37px', marginLeft: '40px', marginRight: '40px', }}>
                <Col span={8}>
                    <div style={{ height: '236px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background1})`, backgroundSize: 'cover', }}>
                        <Row style={{ height: '44px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API授权App总数</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentAPPTotal}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '58px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Col><a style={Styles.cardCount}>
                                {APIAppTotal}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    个</a>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={8}>
                    <div style={{ height: '236px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background2})`, backgroundSize: 'cover', }}>
                        <Row style={{ height: '44px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API授权开发者总数</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentDeveloperTotal}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '58px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Col><a style={Styles.cardCount}>
                                {APIDeveloperTotal}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    个</a>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={8}>
                    <div style={{ height: '110px', padding: '0px', backgroundImage: `url(${Background3})`, backgroundSize: 'cover', }}>

                        <Row style={{ height: '40px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API总绑定用户数</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentTotalBinding}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Col><a style={Styles.cardCount}>
                                {APIBindUserTotal}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    个</a>
                            </Col>
                        </Row>
                    </div>
                    <div style={{ marginTop: '16px', height: '110px', padding: '0px', backgroundImage: `url(${Background3})`, backgroundSize: 'cover', }}>

                        <Row style={{ height: '40px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API授权用户总绑定用户数</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentTotalBinding2}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '14px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Col><a style={Styles.cardCount}>
                                {APIBindUserPart}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    个</a>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <Row style={{ marginTop: '27px', marginLeft: '40px', marginRight: '40px', }}>
                <Col span={8}>
                    <div style={{ height: '140px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background4})`, backgroundSize: 'cover', }}>
                        <Row style={{ height: '40px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API总Push量</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentPush}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={Styles.cardData}>
                            <Col><a style={Styles.cardCount}>
                                {APIPushTotal}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    条</a>
                            </Col>
                        </Row>
                    </div>
                    <div style={{ marginTop: '27px', height: '140px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background4})`, backgroundSize: 'cover', }}>
                        <Row style={{ height: '40px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API授权用户总Push量</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentPush2}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={Styles.cardData}>
                            <Col><a style={Styles.cardCount}>
                                {APIPushPart}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    条</a>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={8}>
                    <div style={{ height: '140px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background5})`, backgroundSize: 'cover', }}>
                        <Row style={{ height: '40px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API总Pull量</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentPull}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={Styles.cardData}>
                            <Col><a style={Styles.cardCount}>
                                {APIPullTotal}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    条</a>
                            </Col>
                        </Row>
                    </div>
                    <div style={{ marginTop: '27px', height: '140px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background5})`, backgroundSize: 'cover', }}>
                        <Row style={{ height: '40px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API授权用户总Pull量</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentPull2}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={Styles.cardData}>
                            <Col><a style={Styles.cardCount}>
                                {APIPullPart}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    条</a>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={8}>
                    <div style={{ height: '140px', padding: '0px', backgroundImage: `url(${Background6})`, backgroundSize: 'cover', }}>

                        <Row style={{ height: '44px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API总PubSub量</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentPubSub}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={Styles.cardData}>
                            <Col><a style={Styles.cardCount}>
                                {APIPubSubTotal}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    条</a>
                            </Col>
                        </Row>
                    </div>
                    <div style={{ marginTop: '27px', height: '140px', padding: '0px', backgroundImage: `url(${Background6})`, backgroundSize: 'cover', }}>

                        <Row style={{ height: '44px' }}>
                            <Col span={22}>
                                <span style={Styles.cardTitle}> API授权用户总PubSub量</span>
                            </Col>
                            <Col span={2} >
                                <Popover placement="bottomRight" content={contentPubSub2}>
                                    <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                </Popover>
                            </Col>
                        </Row>
                        <Row style={Styles.cardData}>
                            <Col><a style={Styles.cardCount}>
                                {APIPubSubPart}</a></Col>
                            <Col>
                                <a style={Styles.cardCompany}>
                                    条</a>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </div>
    )
    function toThousands(num) {
        var num = (num || 0).toString(), re = /\d{3}$/, result = '';
        while (re.test(num)) {
            result = RegExp.lastMatch + result;
            if (num !== RegExp.lastMatch) {
                result = ',' + result;
                num = RegExp.leftContext;
            }
            else {
                num = '';
                break;
            }
        }
        if (num) { result = num + result; }
        return result;
    }
}
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '25px'
    },
    cardTitle: {
        fontSize: '20px',
        color: '#767676',
        display: 'block',
        lineHeight: '22px',
        paddingTop: '20px',
        marginLeft: '24px',

    },
    cardData: {
        marginTop: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'

    },
    cardCount: {
        fontSize: '50px',
        fontWeight: 'normal',
        color: 'rgba(0, 0, 0, 0.85)',
        display: 'block',
        lineHeight: '38px',
    },
    cardCompany: {
        marginTop: '16px',
        fontSize: '20px',
        fontWeight: 'normal',
        color: '#000000',
        display: 'block',
        lineHeight: '22px',
    }

}
const contentAPPTotal = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有获得永久授权的App数量总和。</div>
        <div style={{ fontSzie: '14px', }}>永久授权App定义：</div>
        <div style={{ fontSzie: '14px', }}>1.过期时间为2099年的App</div>
        <div style={{ fontSzie: '14px', }}>2.没有过期时间限制的特定用户</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2013-04-至今</div>
    </div>
);
const contentDeveloperTotal = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有获得永久授权的App数量总和。</div>
        <div style={{ fontSzie: '14px', }}>永久授权App定义：</div>
        <div style={{ fontSzie: '14px', }}>1.过期时间为2099年的App</div>
        <div style={{ fontSzie: '14px', }}>2.没有过期时间限制的特定用户</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2013-04-至今</div>
    </div>
);
const contentTotalBinding = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有App的绑定用户数量总和。</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2012-11-至今</div>
    </div>
);
const contentTotalBinding2 = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有获得永久授权的App的绑定用户数量总和。</div>
        <div style={{ fontSzie: '14px', }}>1.过期时间为2099年的App</div>
        <div style={{ fontSzie: '14px', }}>2.没有过期时间限制的特定用户</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2013-04-至今</div>
    </div>
);
const contentPush = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有App Push量总和。</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2021-08-至今</div>
    </div>
);
const contentPush2 = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有获得永久授权的App Push量总和。</div>
        <div style={{ fontSzie: '14px', }}>永久授权App定义：</div>
        <div style={{ fontSzie: '14px', }}>1.过期时间为2099年的App</div>
        <div style={{ fontSzie: '14px', }}>2.没有过期时间限制的特定用户</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2021-08-至今</div>
    </div>
);
const contentPull = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有App Pull量总和。</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2022-07-至今</div>
    </div>
);
const contentPull2 = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有获得永久授权的App Pull量总和。</div>
        <div style={{ fontSzie: '14px', }}>永久授权App定义：</div>
        <div style={{ fontSzie: '14px', }}>1.过期时间为2099年的App</div>
        <div style={{ fontSzie: '14px', }}>2.没有过期时间限制的特定用户</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2022-07-至今</div>
    </div>
);
const contentPubSub = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有App PubSub量总和。</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2021-08-至今</div>
    </div>
);
const contentPubSub2 = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：美国服务器中所有获得永久授权的App PubSub量总和。</div>
        <div style={{ fontSzie: '14px', }}>永久授权App定义：</div>
        <div style={{ fontSzie: '14px', }}>1.过期时间为2099年的App</div>
        <div style={{ fontSzie: '14px', }}>2.没有过期时间限制的特定用户</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2021-08-至今</div>
    </div>
);
export default APIDataTitlePage